import { FiCheckCircle } from "react-icons/fi";

interface ProfessionalService {
  id: number;
  name: string;
  duration_minutes: number;
}

interface ActivityStepProps {
  selectedType: string;
  accentColor: string;
  services: ProfessionalService[];
  onSelect: (type: string, durationMinutes: number) => void;
}

function ActivityStep({
  selectedType,
  accentColor,
  services,
  onSelect,
}: ActivityStepProps) {
  if (services.length === 0) {
    return (
      <div className="space-y-5 animate-fadeIn">
        <div className="text-center mb-6">
          <h4 className="text-lg font-semibold text-black dark:text-white">
            Tipo de Atividade
          </h4>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Escolha o tipo de aula que deseja agendar
          </p>
        </div>
        <div className="rounded-lg border border-stroke bg-gray-50 p-8 text-center dark:border-strokedark dark:bg-meta-4">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Nenhum serviço disponível. Entre em contato com o profissional.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5 animate-fadeIn">
      <div className="text-center mb-6">
        <h4 className="text-lg font-semibold text-black dark:text-white">
          Tipo de Atividade
        </h4>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Escolha o tipo de aula que deseja agendar
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3">
        {services.map((service) => (
          <button
            key={service.id}
            type="button"
            onClick={() => {
              onSelect(service.name, service.duration_minutes);
            }}
            className={`relative rounded-xl border-2 p-4 text-left transition-all ${
              selectedType === service.name
                ? "shadow-lg"
                : "border-stroke hover:border-gray-300 dark:border-strokedark dark:hover:border-gray-600"
            }`}
            style={
              selectedType === service.name
                ? {
                    borderColor: accentColor,
                    backgroundColor: `${accentColor}10`,
                  }
                : {}
            }
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h5 className="font-semibold text-black dark:text-white">
                  {service.name}
                </h5>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                  Duração: {service.duration_minutes} minutos
                </p>
              </div>
              {selectedType === service.name && (
                <FiCheckCircle size={24} style={{ color: accentColor }} />
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ActivityStep;
